import { VendureUserIdentity } from "@scalingworks/refine-react-admin/src/types";

export const getChannel = (identity: VendureUserIdentity) => {
  const channelCode = import.meta.env.VITE_CHANNEL_CODE || '__default_channel__';
  const channel = identity.me?.channels?.find(channel => channel.code === channelCode);

  return channel;
}